define('utils/set',[],function() {
    var Set = function() {
    };

    Set.prototype.add = function(o) {
        this[o] = true;
    };

    Set.prototype.remove = function(o) {
        delete this[o];
    };

    Set.prototype.removeAll = function() {
        for (var env in this) {
            delete this[env];
        }
    };

    Set.prototype.contains = function(o) {
        return this.hasOwnProperty(o);
    };

    Set.prototype.asArray = function() {
        return Object.keys(this);
    };

    return Set;
});

